import { fShortenNumber } from "minimals-template/components/utils/formatNumber"
import { comparisonMinutes, formatSeconds } from "./precision.mjs"

export function formatComparedDurations(former, current) {
    const from = formatTime(former)
    const to = formatTime(current)
    if (from === to && comparisonMinutes(former) !== comparisonMinutes(current)) {
        return { from: formatSeconds(former), to: formatSeconds(current) }
    }
    return { from, to }
}

export function formatTimeChange(minutes) {
    const magnitude = comparisonMinutes(Math.abs(minutes))
    if (!magnitude) return "0 mins"
    const label = magnitude < 0.5 ? formatSeconds(magnitude) : formatTime(magnitude)
    return `${minutes > 0 ? "+" : "-"}${label}`
}

export function formatTime(timeInMinutes) {
    if (Math.abs(timeInMinutes) > 240) {
        if (Math.abs(timeInMinutes) > 60 * 24 * 2) {
            return `${fShortenNumber(timeInMinutes / (60 * 8))} w/day${
                +fShortenNumber(timeInMinutes / (60 * 8)) !== 1 ? "s" : ""
            }`
        }
        return `${fShortenNumber(timeInMinutes / 60)} hour${+fShortenNumber(timeInMinutes / 60) !== 1 ? "s" : ""}`
    }
    return `${fShortenNumber(timeInMinutes)} min${+fShortenNumber(timeInMinutes) !== 1 ? "s" : ""}`
}

export function formatTimeShort(timeInMinutes) {
    if (Math.abs(timeInMinutes) > 240) {
        if (Math.abs(timeInMinutes) > 60 * 24 * 2) {
            return `${fShortenNumber(timeInMinutes / (60 * 8))} w/day${
                +fShortenNumber(timeInMinutes / (60 * 8)) !== 1 ? "s" : ""
            }`
        }
        return `${fShortenNumber(timeInMinutes / 60)}h`
    }
    return `${fShortenNumber(timeInMinutes)}m`
}
